import React from "react";
import "./skills_card.scss";

import { workData } from "./work-data";

const Skills_Card = () => {
  return (
    <div className="mirror-skills">
      <div className="mirror-skills__inside">
        <h3 className="mirror-skills__inside__title heading-secondary">
          Skills
        </h3>
        {workData.map((skill, i) => (
          <div className="card-tech" key={i}>
            <img src={skill.image} alt="" className="card-tech__image" />
            <p className="card-tech__name">{skill.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills_Card;
